import { Component, Input } from '@angular/core';
import { LoStatus, LoTooltip } from 'lo-design-system';
import {
	Capability,
	WarningInline
} from '@brand-lolly/app/_models/brand-instagram-integration.model';

const FEATURE_LABELS: Record<Capability, string> = {
	dm: 'Direct messaging',
	ads: 'Ads',
	insights: 'Insights',
	publish: 'Publish',
	mentions: 'Mentions',
	creator_marketplace: 'Marketplace',
	partnership_ads: 'Partnership Ads',
	social_listening: 'Social listening',
	moderate: 'Moderate',
	manage: 'Manage'
};

@Component({
	standalone: true,
	selector: 'meta-warning-pill',
	imports: [LoStatus, LoTooltip],
	template: `
		<lo-status [tone]="tone" [loTooltip]="warning.message">
			{{ label }}
		</lo-status>
	`
})
export class MetaWarningPillComponent {
	@Input({ required: true }) warning!: WarningInline;

	get tone(): 'danger' | 'warning' | 'info' {
		if (
			this.warning.severity === 'error' ||
			this.warning.severity === 'action_required'
		) {
			return 'danger';
		}
		return this.warning.severity === 'info' ? 'info' : 'warning';
	}

	get label(): string {
		if (this.warning.feature) {
			return FEATURE_LABELS[this.warning.feature] ?? this.warning.feature;
		}
		return this.warning.code.replace(/_/g, ' ');
	}
}
